import graphql from 'babel-plugin-relay/macro';
import React from 'react';
import {useLazyLoadQuery} from 'react-relay/hooks';
import {usePerPage} from 'src/hooks/usePerPage';
import {withSuspense} from 'src/utils/withSuspense';

import {listPageHydrantFamiliesQuery} from './__generated__/listPageHydrantFamiliesQuery.graphql';
import HydrantFamiliesTable from './HydrantFamiliesTable';

function ListPage() {
  const {perPage} = usePerPage();
  const data = useLazyLoadQuery<listPageHydrantFamiliesQuery>(
    hydrantFamilies,
    {first: perPage * 2},
    {fetchPolicy: 'store-and-network'},
  );

  return <HydrantFamiliesTable hydrantFamilies={data} />;
}

export default withSuspense(ListPage);

const hydrantFamilies = graphql`
  query listPageHydrantFamiliesQuery($first: Int!) {
    ...HydrantFamiliesTable_hydrantFamilies @arguments(first: $first)
  }
`;
